import ApiError from '~/types/ApiError';

/** Normalise API/network errors for JSON debug display on credit-grant flows. */
export function errorPayloadForDisplay(error: unknown): unknown {
  if (error instanceof ApiError && error.responseBody !== undefined) {
    return error.responseBody;
  }
  if (error instanceof ApiError) {
    return {
      name: error.name,
      message: error.message,
      ...(error.status !== undefined ? { status: error.status } : {}),
      ...(error.errors !== undefined ? { errors: error.errors } : {}),
    };
  }
  if (error instanceof Error) {
    return { name: error.name, message: error.message };
  }
  return { message: String(error) };
}
